<template>
  <div class="header-login">
    <v-flex>
      <v-btn v-if="!loggedIn" color='primary' dark @click='dialog=true'>LOGIN</v-btn>
      <v-btn v-else color='primary' dark @click='logoutUser'>LOGOUT</v-btn>

      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <div style='{padding: 10;}'>
            <v-card-title class="headline">Login {{ tpc ? '(TPC)' : '' }}</v-card-title>
            <span v-if='tpc'>Twisty Puzzle Cup competitors must sign in using WCA</span>
            <v-btn color='primary' dark :disabled='tpc' @click='facebookLoginUser(); dialog=false'><v-icon>fab fa-facebook-f</v-icon>&nbsp;&nbsp;&nbsp;LOGIN WITH FACEBOOK</v-btn>
            <v-btn color='white' :disabled='tpc' @click='googleLoginUser(); dialog=false'><v-icon color='#4285f4'>fab fa-google</v-icon>&nbsp;&nbsp;&nbsp;LOGIN WITH GOOGLE</v-btn>
            <v-btn color='success' @click='wcaLoginUser(); dialog=false'><img height='100%' src='../assets/wcalogo.svg'>&nbsp;&nbsp;&nbsp;LOGIN WITH WCA</v-btn>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="dialog = false"
              >
                CLOSE
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </v-flex>
  </div>
</template>

<script>
/* global FB */
import UsersService from '@/services/UsersService'

export default {
  name: 'header-login',
  data () {
    return {
      dialog: false
    }
  },
  props: {
    loggedIn: Boolean,
    tpc: Boolean,
  },
  methods: {
    async facebookLoginUser () {
      let self = this
      FB.login(function (response) {
        if (response.authResponse) {
          (async (fbResponse) => {
            let response = await UsersService.getToken({
              access_token: fbResponse.authResponse.accessToken
            }, 'facebook')
            console.log(response.data)
            self.commitLoginUser(response)
          })(response)
        } else {
          alert('Login Unsuccessful. Could not connect to Facebook')
        }
      })
    },
    async googleLoginUser () {
      let googleUser = await this.$gAuth.signIn()
      let response = await UsersService.getToken({access_token: googleUser.getAuthResponse().id_token}, 'google')
      console.log(response.data)
      this.commitLoginUser(response)
    },
    async wcaLoginUser () {
      this.$router.push({ path: '/wca/login', query: {path: this.$route.path} }) // TODO: add some query params to /wca/login to redirect either to TPC or Root page
    },
    commitLoginUser (response) {
      if (response.data.success === true) {
        this.$store.commit('setSolverId', response.data.user._id)
        this.$store.commit('setSolver', response.data.user.username)
        this.$store.commit('setGlobalAuthToken', response.data.authToken)

        localStorage.setItem('globalSolver', this.$store.state.solver)
        localStorage.setItem('globalSolverId', this.$store.state.solverId)
        localStorage.setItem('globalAuthToken', this.$store.state.globalAuthToken)
        alert('Successfully logged in')
      } else {
        alert('Failed to login due to error: ' + response.data.error)
      }
    },
    commitLogoutUser () {
      this.$store.commit('setSolverId', '')
      this.$store.commit('setSolver', '')
      this.$store.commit('setGlobalAuthToken', '')

      localStorage.removeItem('globalSolver')
      localStorage.removeItem('globalSolverId')
      localStorage.removeItem('globalAuthToken')
      this.$router.push({ path: `/` })
    },
    async logoutUser () {
      let self = this
      FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          FB.logout(function (response) {
            if (response.authResponse) {
              console.log('Logged out from Facebook')
              self.commitLogoutUser()
            }
          })
        }
      })
      this.$gAuth.signOut()
      window.open(`${this.$backendApi}/auth/logout?path=${this.$route.path}`, '_self')
      this.commitLogoutUser()
    }
  }
}
</script>

<style scoped>
::v-deep .v-btn__content {
  height: inherit;
}

/* Makes the disabled facebook login visible on TPC */
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: rgb(0, 54, 105)!important;
}
</style>
